import React, { useState, useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import salesService from "../../services/sales-service";
import GlobalVariable from "../../../../client/src/services/globalVar";
import InvoiceService from "../../../../client/src/services/invoice-service";
import Item from "antd/es/list/Item";
import JournalService from "../../services/journal";
import { BlockUI } from "primereact/blockui";
import { ProgressSpinner } from "primereact/progressspinner";
import { Dialog, InputTextarea, Toast, ToggleButton } from "../PrimeReact";
import purchaseService from "../../services/purchase-sevice";
import { format } from "date-fns";
import { MdInfoOutline } from "react-icons/md";

const ReceiptVoucherForm = (props) => {
  const ss = new salesService();
  const is = new InvoiceService();
  const jor = new JournalService();
  const ps = new purchaseService();
  //  useEffect(() => {
  //     // Cleanup on unmount
  //     return () => {
  //       Object.values(is.controllers).forEach((c) => c.abort());
  //       is.controllers = {};
  
  //       Object.values(ps.controllers).forEach((c) => c.abort());
  //       ps.controllers = {};
  
  //       Object.values(ss.controllers).forEach((c) => c.abort());
  //       ss.controllers = {};
  
  //       Object.values(jor.controllers).forEach((c) => c.abort());
  //       jor.controllers = {};
  //     };
  //   }, []);
  const toast = useRef(null);
  const [customers, setCustomers] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [accountData, setAccountData] = useState([{ label: "", value: "", id: "" }]);
  const [subCategory, setSubCategory] = useState([]);
  const [fullAmount, setFullAmount] = useState([]);
  const [custDetails, setCustDetails] = useState([]);
  const [isProcess, setIsProcess] = useState(false);
  const [isFullAmountChecked, setIsFullAmountChecked] = useState(false);
  const [vendorNameList, setVendorNameList] = useState([]);
  const [selectVendorNameList, setSelectVendorNameList] = useState();
  const [selectPaymentMode, setSelectPaymentMode] = useState();
const [depositBank, setDepositBank] = useState(false);
const [bankAccData, setBankAccData] = useState([]);
const [selectedBankAccount, setSelectedBankAccount] = useState();

  const defaultValues = {
    vendorname: null,
    amountReceived: "",
    bankCharges: "",
    paymentDate: new Date(),
    paymentNumber: "",
    paymentMode: null,
    bank:"",
    depositTo: null,
    referenceNumber: "",
    taxDeducted: "No Tax deducted",
  };

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    register,
    reset,
  } = useForm({ mode: "onChange", defaultValues });

  const paymentModes = [
    { label: "Cash", value: "Cash" },
    { label: "Credit Card", value: "Credit Card" },
    { label: "Cheque", value: "Cheque" },
    { label: "Bank Transfer", value: "Bank Transfer" },
  ];

  // const handleCheckboxChange = (e) => {
  //   const updatedInvoices = [...invoices];
  //   setIsFullAmountChecked(e.checked);
  //   if (e.checked) {
  //     setValue("amountReceived", fullAmount);
  //     updatedInvoices.forEach((a,i) => a.payment = a.balancePayment)
  //   } else {
  //     setValue("amountReceived", 0);
  //     updatedInvoices.forEach((a,i) => a.payment = 0)

  //   }
  // };
  const handleCheckboxChange = (e) => {
    const isChecked = e.checked;
    const updatedInvoices = invoices.map((invoice) => ({
        ...invoice,
        payment: isChecked ? invoice.balancePayment : 0, 
    }));

    setInvoices(updatedInvoices); 
    setIsFullAmountChecked(isChecked); 
    const totalAmount = isChecked ? fullAmount : 0;
    setValue("amountReceived", totalAmount); 
};

  // const handlePayFullCheckboxChange = (index, checked) => {
  //   const updatedInvoices = [...invoices];
  //   if (checked) {
  //     updatedInvoices[index].payment = updatedInvoices[index].balancePayment;
  //   } else {
  //     updatedInvoices[index].payment = 0;
  //   }
  //   setInvoices(updatedInvoices);
  // };
  const handlePayFullCheckboxChange = (index, checked) => {
    const updatedInvoices = [...invoices];
    updatedInvoices[index].payment = checked ? updatedInvoices[index].balancePayment : 0;
    setInvoices(updatedInvoices);

    const allChecked = updatedInvoices.every(
        (invoice) => invoice.payment === invoice.balancePayment
    );
    setIsFullAmountChecked(allChecked);

    const totalAmount = updatedInvoices.reduce((sum, invoice) => sum + Number(invoice.payment || 0), 0);
    setValue("amountReceived", totalAmount);
};

  // const handlePaymentChange = (index, value) => {
  //   const updatedInvoices = [...invoices];
  
  //   if (value === '') {
  //     // Allow clearing the input field temporarily
  //     updatedInvoices[index].payment = '';
  //   } else {
  //     // Ensure the value does not exceed balancePayment
  //     updatedInvoices[index].payment = Math.min(
  //       Number(value),
  //       updatedInvoices[index].balancePayment
  //     );
  //   }
  
  //   setInvoices(updatedInvoices);
  // };
  const handlePaymentChange = (index, value) => {
    const updatedInvoices = [...invoices];
  
    updatedInvoices[index].payment = value === ''
        ? '' 
        : Math.min(Number(value), updatedInvoices[index].balancePayment); 
  
    setInvoices(updatedInvoices);

    const totalAmount = updatedInvoices.reduce((sum, invoice) => sum + Number(invoice.payment || 0), 0);
    setValue("amountReceived", totalAmount);

    const allChecked = updatedInvoices.every(
        (invoice) => invoice.payment === invoice.balancePayment
    );
    setIsFullAmountChecked(allChecked);
};


  const calculateAmountPaid = () => {
    return invoices.reduce(
      (total, invoice) => total + (invoice.payment || 0),
      0
    );
  };

  const GetContact = () => {
    setIsProcess(true);
    const data = {
      TenantID: GlobalVariable.userDet.tenantDetail.tenantID,
      ContactType: "Customer",
      CustomerType: "all",
      Status: "Active",
    };
    is.GetContact(data).then((res) => {
      setIsProcess(false);
      setCustomers(res.data.data);
    });
  };

  const customerDetails = (option) => {
    return (
      <div className="flex align-items-center">
        <div>
          {option.fullName} ( {option.companyName} )
        </div>
      </div>
    );
  };

  function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  const deposito = (value) => {
  const matchedAccount = accountData[0].category.find((account) => account.coaName === value);
  setDepositBank(matchedAccount || false);
  const datas = {
    Status: "active",
    TenantID: GlobalVariable.userDet.tenantDetail.tenantID,
  };
  jor.GetBankAccountList(datas).then((res) => {
    setBankAccData(res.data.data);
  });
};

 const GetMasCOACategories = () => {
    const data = {
      COAMasID: 0,
      TenantID: GlobalVariable.userDet.tenantDetail.tenantID,
      Status: "Active",
      COAType: "All",
    };
    ps.GetMasCOACategories(data).then((res) => {
    });
  };

  const bankaccount = (e) => {
    setSelectedBankAccount(e)
     }
  const onSubmit = (data) => {
    setIsProcess(true);
    const coa = subCategory.find((x) => x.coaName === data.depositTo);

    const createdon = new Date();
    const formattedInvoiceDate1 = createdon.toISOString().split("T")[0];

    const datas = {
      ContactPaymentID: 0,
      ContactID: custDetails.contactID,
      CompanyName: custDetails.companyName,
      FirstName: custDetails.firstName,
      LastName: custDetails.lastName,
      ContactType: custDetails.contactType,
      "bankID": selectedBankAccount?.bankAcctID || 0,
      "bankAcctName": selectedBankAccount?.accountName || null,
      PaymentCategory: "Purchase",
      ContactPaymentCode: data.paymentNumber,
      PaymentDate: formatDate(new Date(data.paymentDate)),
      PaymentMode: data.paymentMode,
      Reference: data.referenceNumber,
      AmountReceievd: data.amountReceived,
      AmountPayment: amountUsedForPayments.toFixed(2),
      AmountExcess: amountInExcess.toFixed(2),
      Notes: "",
      COAID: coa.coaMasID,
      COACode: coa.code,
      COAName: coa.coaName,
      TenantID: GlobalVariable.userDet.tenantDetail.tenantID,
      CreatedOn: formattedInvoiceDate1,
      CreatedBy: GlobalVariable.userDet.appUser.appuserID,
      PaymentInstanceInfo: invoices.map((a, i) => ({
        ContactPaymentInstID: 0,
        ContactPaymentID: 0,
        ContactID: custDetails.contactID,
        ContactType: "Vendor",
        CompanyName: custDetails.companyName,
        FirstName: custDetails.firstName,
        LastName: custDetails.lastName,
        PaymentMode: data.paymentMode,
        EntityID: a.purchaseID,
        EntityType: "Purchase",
        EntityDate: a.purchaseDate,
        EntityDueDate: null,
        EntityUniqueNumber: a.purchaseCode,
        TotalAmount: a.totalAmount,
        BalanceAmount: a.balancePayment,
        PaymentAmount: a.payment,
        COAID: coa.coaMasID,
        COACode: coa.code,
        COAName: coa.coaName,
        TenantID: GlobalVariable.userDet.tenantDetail.tenantID,
        CreatedOn: formattedInvoiceDate1,
      })),
    };
    ss.SaveContactPaymentDetails(datas).then((res) => {
      setIsProcess(false);
      if (res.data.message === "Saved Successfully") {
        toast.current.show({
          severity: "success",
          summary: res.data.message,
        });
      }
      // setIsPaymentVoucher();
      props.data.setIsReceiptVoucher();
    });
  };

  const vendorname = watch("vendorname");
  const amountReceived = watch("amountReceived");
  const amountUsedForPayments = invoices.reduce(
    (sum, invoice) => sum + parseFloat( props.data.viewRowData ? invoice.paymentAmount : invoice.payment || 0),
    0
  );
  const amountInExcess = amountReceived - amountUsedForPayments;

  const getCustInvoice = (item) => {
    setIsProcess(true);
    const data = {
      TenantID: GlobalVariable.userDet.tenantDetail.tenantID,
      VendorID: item.contactID,
    };

    ss.GetVendorPurchase(data).then((res) => {
      setIsProcess(false);
      const invoicesData = res.data.data;
      setInvoices(invoicesData);
      const totalAmountSum = invoicesData.reduce(
        (sum, invoice) => sum + (invoice.balancePayment || 0),
        0
      );
      setFullAmount(totalAmountSum.toFixed(2));
      setValue("amountReceived", 0);
      setIsFullAmountChecked(false);
      
    });
  };

  const paymentNums = () => {
    setIsProcess(true);
    const data = {
      TenantID: GlobalVariable.userDet.tenantDetail.tenantID,
      ServiceName: "VendorPayment",
    };
    ss.GenerateConfigNumbers(data).then((res) => {
      setValue("paymentNumber", res.data.data);
      setIsProcess(false);
    });
  };

  const GetContactFilteredList = () => {
    const data = {
      TenantID: GlobalVariable.userDet.tenantDetail.tenantID,
      ContactType: "Vendor",
      SearchData: "",
    };
    ps.GetContactFilteredList(data).then((res) => {
      const contactName = res.data.data.map((a) => {
        return a;
      });
      setVendorNameList(contactName);
      if (props.data.viewRowData) {
        const bindVal = res.data.data.find(
          (a) => a?.contactID === props.data.viewRowData.contactID
        );
        setSelectVendorNameList(bindVal);
        setValue("vendorname", bindVal);
      }
      //   if (selectedPurchase) {
      //     let vndr = res.data.data.find(
      //       (x) => x?.contactID === selectedPurchase.vendorID
      //     );
      //     setSelectVendorNameList(vndr);
      //     setValue("vendorname", vndr);
      //   }
    });
  };

  const initMethods = () => {
    setIsProcess(true);
    jor
      .GetMasCOA(
        0,
        GlobalVariable.userDet.tenantDetail.tenantID,
        "Active",
        "All"
      )
      .then((response) => {
        let b = [];
        if (response.data) {
          if (response.data.statusCode === 200) {
            setIsProcess(false);
            setAccountData(response.data.data);
            response.data.data.map((acc) => {
              acc.category.map((sub) => {
                return b.push(sub);
              });
              acc.subCategory.map((sub) => {
                return b.push(sub);
              });
            });
            setSubCategory(b);
          } else {
          }
        }
      })
      .catch(function (error) {});
  };

  const accountOptions = accountData.map((acc) => {
    return {
      label: acc.type,
      code: acc.type,
      items: subCategory
        .filter((sub) => sub.coaType === acc.type)
        .map((s) => {
          return {
            label: s.coaName,
            value: s.coaName,
            id: s.coaMasID,
            category: s.coaCategory,
            type: s.coaType,
          };
        }),
    };
  });

  const groupedItemTemplate = (option) => {
    return (
      <div>
        <div className="">{option.label}</div>
      </div>
    );
  };

  const vendorNameOnchange = (e) => {
    setSelectVendorNameList(e);
    setCustDetails(e);
    if (props.data.viewRowData.length === 0) {
      getCustInvoice(e);
    }
  };

  const vendorPaymentModeOnchange = (e) => {
    setSelectPaymentMode(e);
  };

  const dateFormBodyTemplate = (rowData) => {
    return (
      <div>
        {format(
          new Date(rowData ),
          GlobalVariable.userDet.tenantConfig.dateFormat
        )}
      </div>
    );
  };

  useEffect(() => {
    if (props.data.viewRowData) {
      setValue("amountReceived", props.data.viewRowData.amountReceievd);
      setValue("referenceNumber", props.data.viewRowData.reference);
      setValue("paymentNumber", props.data.viewRowData.contactPaymentCode);
      setValue("depositTo", props.data.viewRowData.coaName);
      if(props.data.viewRowData.coaName === "Bank") {
              const datas = {
                "Status": "active",
                "TenantID": GlobalVariable.userDet.tenantDetail.tenantID
              }
              jor.GetBankAccountList(datas).then((res) =>
              { 
                setBankAccData(res.data.data);
                const bacc = res.data.data.find((a) => a.accountName === props.data.viewRowData.bankAcctName);
                setSelectedBankAccount(bacc);
                setValue("bank", props.data.viewRowData.bankAcctName);
              }
              )
              setDepositBank(true);
            } else {
              setDepositBank(false);
            }
      const pm = paymentModes.find(
        (a) => a.value === props.data.viewRowData.paymentMode
      );
      setValue("paymentMode", pm.value);
      const paymentDate = new Date(props.data.viewRowData.paymentDate);
      setValue("paymentDate", paymentDate);
      ss.GetContactPaymentInstance(
        GlobalVariable.userDet.tenantDetail.tenantID,
        props.data.viewRowData.contactPaymentID
      )
        .then((res) => {
          setInvoices(res.data.data);
        })
        .catch((err) => console.log(err));
    }
    GetContact();
    initMethods();
    paymentNums();
    GetContactFilteredList();
    GetMasCOACategories();
  }, []);

  return (
    <BlockUI blocked={isProcess}>
      <Toast ref={toast}></Toast>

      <div className="container-fluid">
        <div className="card card-borderless cc-greyCard-custm mb-3">
          <div className="ms-2 my-2 me-2">
            <div className="d-flex justify-content-between flex-wrap my-2">
              <h4 className="m-0">Receipt Voucher</h4>
              <div className="d-flex justify-content-end kk-table-header kk-header-sec cc-font-size-14">
                <Button
                  className="btn btn-danger py-1 me-2 mx-2 kk-btnThin my-auto"
                  type="button"
                  label="Back"
                  onClick={props?.data?.setIsReceiptVoucher}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="card card-borderless cc-greyCard-custm mb-3">
          <div className="ms-2 my-2 me-2 p-2">
            <form onSubmit={handleSubmit(onSubmit)} className="mb-5">
              <div className="row mb-3">
                <div className="col-md-3">
                  <label className="form-label required">Vendor Name</label>{" "}
                  <Controller
                    name="vendorname"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Dropdown
                        {...field}
                        value={selectVendorNameList}
                        onChange={(e) => {
                          field.onChange(e.value);
                          vendorNameOnchange(e.value);
                        }}
                        options={vendorNameList}
                        disabled={props.data.viewRowData}
                        itemTemplate={customerDetails}
                        optionLabel="fullName"
                        placeholder="Select vendor"
                        className="form-control"
                      />
                    )}
                  />
                  {errors.vendorname && (
                    <p className="text-danger">This field is required</p>
                  )}
                </div>
                {vendorname && (
                  <>
                    <div className="col-md-3">
                      <div className="d-flex  align-items-center">
                        <label className="form-label required">
                          Amount Received
                        </label>
                        <Checkbox
                          checked={isFullAmountChecked}
                          onChange={handleCheckboxChange}
                          disabled={props.data.viewRowData}
                          className="ms-2"
                          inputId="receivedFullAmount"
                        />
                        <label htmlFor="receivedFullAmount" className="ms-1">
                          Received full amount (
                          {GlobalVariable.userDet.tenantConfig.currency +
                            "" +
                            fullAmount}
                          )
                        </label>
                      </div>
                      <div className="d-flex align-items-center">
                        <input
                          name="amountReceived"
                          className="form-control"
                          
                          disabled={ props.data.viewRowData}
                          {...register("amountReceived", { required: true })}
                        />
                      </div>
                      {errors.amountReceived && (
                        <p className="text-danger mb-0">
                          This field is required
                        </p>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Reference Number</label>
                      <Controller
                        name="referenceNumber"
                        control={control}
                        render={({ field }) => (
                          <InputText {...field} 
                        disabled={props.data.viewRowData}
                        className="form-control" />
                        )}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label required">
                        Payment Date
                      </label>
                      <Controller
                        name="paymentDate"
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                          <Calendar {...field} 
                        disabled={props.data.viewRowData}
                        maxDate={new Date()}
                        className="form-control p-0" />
                        )}
                      />
                      {errors.paymentDate && (
                        <p className="text-danger">This field is required</p>
                      )}
                    </div>
                  </>
                )}
              </div>

              {vendorname && (
                <div className="row mb-3">
                  <div className="col-md-3">
                    <label className="form-label">Voucher Number</label>
                    <Controller
                      name="paymentNumber"
                      control={control}
                      render={({ field }) => (
                        <InputText
                          {...field}
                          className="form-control"
                          disabled
                        />
                      )}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label required">Payment Mode</label>
                    <Controller
                      name="paymentMode"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <Dropdown
                          {...field}
                          // value={selectPaymentMode}
                          options={paymentModes}
                        disabled={props.data.viewRowData}

                          onChange={(e) => {
                            field.onChange(e.value);
                            vendorPaymentModeOnchange(e.value);
                          }}
                          placeholder="Select Payment Mode"
                          className="form-control"
                        />
                      )}
                    />
                    {errors.paymentMode && (
                      <p className="text-danger">This field is required</p>
                    )}
                  </div>
                  <div className="col-md-3">
                    <label className="form-label required">Deposit To</label>
                    <Controller
                      name="depositTo"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <Dropdown
                          {...field}
                          options={accountOptions}
                          {...register("depositTo")}
                          optionGroupTemplate={groupedItemTemplate}
                          disabled={props.data.viewRowData}
                          filter
                          filterBy="label"
                          optionValue="value"
                          optionGroupLabel="label"
                          optionGroupChildren="items"
                          placeholder="Select Deposit Account"
                          optionLabel="label"
                          className="form-control"
                          onChange={(e) => {
                            field.onChange(e.value);
                            deposito(e.value); 
                          }}
                        />
                      )}
                    />
                    {errors.depositTo && (
                      <p className="text-danger">This field is required</p>
                    )}
                  </div>
                  {depositBank.isBank && (
                    <div className="col-md-3">
                      <label className="form-label required">Bank Account</label>
                      <Controller
                        name="bank"
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                          <Dropdown
                            {...field}
                            options={bankAccData}
                            value={selectedBankAccount}
                            disabled={props.data.viewRowData}
                            placeholder="Select Bank Account"
                            className="form-control"
                            optionLabel="accountName"
                            onChange={(e) => {
                              field.onChange(e.value);
                              bankaccount(e.value); 
                            }}
                          />
                        )}
                      />
                      {errors.bank && (
                        <p className="text-danger">This field is required</p>
                      )}
                    </div>
                  )}
                </div>
              )}
            </form>
            {isProcess && (
              <ProgressSpinner
                style={{
                  width: "50px",
                  height: "50px",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
                strokeWidth="2"
                fill="var(--surface-ground)"
                animationDuration=".5s"
              />
            )}
            {vendorname && (
              <>
                {invoices.length > 0 ? (
  <div className="mt-5">
    <h4>Unpaid Purchases</h4>
    <div
      style={{
        maxHeight: invoices.length > 5 ? "400px" : "auto",
        overflowY: invoices.length > 5 ? "auto" : "visible",
        border: "1px solid #ddd", // Adds a border around the table
      }}
    >
      <table className="table table-striped table-bordered">
        <thead
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1,
            backgroundColor: "#f8f9fa", // Header background color
          }}
        >
          <tr>
            <th style={{ padding: "10px", borderBottom: "2px solid #ddd" }}>
              Date
            </th>
            <th style={{ padding: "10px", borderBottom: "2px solid #ddd" }}>
              Purchase Number
            </th>
            <th
              className="text-end"
              style={{
                padding: "10px",
                borderBottom: "2px solid #ddd",
              }}
            >
              Purchase Amount
            </th>
            <th
              className="text-end"
              style={{
                padding: "10px",
                borderBottom: "2px solid #ddd",
              }}
            >
              Amount Due
            </th>
            <th
              className="text-center"
              style={{
                padding: "10px",
                borderBottom: "2px solid #ddd",
              }}
            >
              Payment
            </th>
          </tr>
        </thead>
        <tbody>
          {invoices.map((invoice, index) => (
            <tr key={index}>
              <td style={{ placeContent: "center" }}>
                {dateFormBodyTemplate(
                  props.data.viewRowData
                    ? invoice.entityDate
                    : invoice.purchaseDate
                )}
              </td>
              <td style={{ placeContent: "center" }}>
                {props.data.viewRowData
                  ? invoice.entityUniqueNumber
                  : invoice.purchaseCode}
              </td>
              <td
                className="text-end"
                style={{ placeContent: "center" }}
              >
                {GlobalVariable.userDet.tenantConfig.currency +
                  "" +
                  invoice.totalAmount?.toFixed(2)}
              </td>
              <td
                className="text-end"
                style={{ placeContent: "center" }}
              >
                {GlobalVariable.userDet.tenantConfig.currency}{" "}
                {props.data.viewRowData
                  ? invoice.balanceAmount.toFixed(2)
                  : invoice.balancePayment.toFixed(2)}
              </td>
              <td style={{ width: "34%" }}>
                <div className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    disabled={props.data.viewRowData}
                    checked={
                      invoice.payment === invoice.balancePayment
                    }
                    onChange={(e) =>
                      handlePayFullCheckboxChange(index, e.target.checked)
                    }
                    className="ms-2"
                  />
                  <label
                    htmlFor={`payFull-${index}`}
                    className="ms-2 mb-0"
                    style={{ width: "12%" }}
                  >
                    Pay Full
                  </label>
                  <input
  type="number"
  value={
    props.data.viewRowData
      ? invoice.paymentAmount
      : invoice.payment === '' ? '' : invoice.payment
  }
  disabled={props.data.viewRowData}
  onChange={(e) => handlePaymentChange(index, e.target.value)}
  className="form-control ms-2"
  min={0}
  max={invoice.balancePayment}
/>

                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
) : (
  <div className="mt-5">
    <div
      className="text-center fs-4"
      style={{ color: "lightslategray" }}
    >
      No Pending Receipts
    </div>
  </div>
)}

              </>
            )}

            {vendorname && invoices.length > 0 && (
              <div className="mt-4">
                <div className="row m-2">
                  <div className="col-md-4"></div>
                  <div className="col-md-5"></div>
                  <div
                    className="col-md-3 text-end p-3"
                    style={{ background: "rgb(226 243 252)" }}
                  >
                    <div className="d-flex justify-content-between">
                      <p>
                        <strong>Total Amount</strong>
                      </p>
                      <p>
                        {GlobalVariable.userDet.tenantConfig.currency +
                          " " +
                          Number(amountReceived || fullAmount).toFixed(2)}
                      </p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p>
                        <strong>Amount Used for Payments</strong>
                      </p>
                      <p>
                        {GlobalVariable.userDet.tenantConfig.currency +
                          " " +
                          amountUsedForPayments.toFixed(2)}
                      </p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p>
                        <strong>Amount in Excess</strong>
                      </p>
                      <p
                        style={{
                          color: amountInExcess < 0 ? "red" : "inherit",
                        }}
                      >
                        {GlobalVariable.userDet.tenantConfig.currency +
                          " " +
                          Math.abs(amountInExcess).toFixed(2)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {amountInExcess !== 0 && <div className="mt-4">
              <div className="row m-2">
                <div className="col-md-4"></div>
                <div className="col-md-5"></div>
                <div
                  className="col-md-3 text-end p-3"
                  style={{ background: "rgb(247 246 216)" }}
                >
                  <div className="d-flex justify-content-between">
                 <p className="m-0">
            <MdInfoOutline className="mx-2" style={{ fontSize: "19px" }} />
            The Amount in Excess must be zero.
          </p>
          
          
                  </div>
                 
                </div>
              </div>
            </div>}
          {!props.data.viewRowData && <div className="text-end m-3 d-flex mt-3 justify-content-end gap-3 p-0">
            <Button
              type="button"
              label="Save"
              className="btn btn-primary my-3"
              onClick={handleSubmit(onSubmit)}
              disabled={amountInExcess !== 0}
            />
            <Button
              className="btn btn-danger my-3"
              type="button"
              label="Cancel"
            />
          </div>}
        </div>
      </div>
    </BlockUI>
  );
};

export default ReceiptVoucherForm;
